import React, { useRef } from 'react';
import classnames from 'classnames';
import InfoTooltip from './info-tooltip';

interface Props {
  children: string;
  className: string;
}

const EllipsisText = ({ children, className }: Props): React.ReactNode => {
  const ellipsisTextContainerRef = useRef<HTMLDivElement>(null);
  const ellipsisTextRef = useRef<HTMLSpanElement>(null);
  const infoTooltip = useRef<InfoTooltip>(null);
  const ellipsisTextClassName = classnames('ellipsis', className);

  const onMouseEnter = () => {
    const {
      scrollWidth: ellipsisTextScrollWidth,
      offsetWidth: ellipsisTextOffsetWidth
    } = ellipsisTextRef.current;
    const isEllipsis = ellipsisTextScrollWidth > ellipsisTextOffsetWidth;

    if (!isEllipsis) {
      return false;
    }

    infoTooltip.current.show();
  };

  const onMouseLeave = () => infoTooltip.current.hide();

  return (
    <div
      className="ellipsis-text-container"
      ref={ellipsisTextContainerRef}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <span ref={ellipsisTextRef} className={ellipsisTextClassName}>
        {children}
      </span>

      <InfoTooltip ref={infoTooltip} alignElement={() => ellipsisTextContainerRef.current}>
        <span className="text">{children}</span>
      </InfoTooltip>
    </div>
  );
};

export default EllipsisText;
